import { McAvatar, McButton } from "@maersk-global/mds-react-wrapper";
import { useAuth } from "../auth";
import { useTheme } from "../context/ThemeContext";
import "./AppHeader.css";

const base = process.env.PUBLIC_URL || "";
const LOGO_LIGHT = `${base}/sonarenduser.svg`;
const LOGO_DARK = `${base}/sonarenduser-dark.svg`;

function getInitials(name) {
  if (!name || !name.trim()) return "?";
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) {
    return (
      parts[0].charAt(0) + parts[parts.length - 1].charAt(0)
    ).toUpperCase();
  }
  return name.charAt(0).toUpperCase();
}

function AppHeader() {
  const { account } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const displayName = account?.name ?? account?.username ?? "User";
  const initials = getInitials(displayName);
  const isDark = theme === "dark";

  return (
    <header className="app-header" role="banner">
      <a
        href="/"
        className="app-header__logo"
        aria-label="Sonar End User Portal home"
      >
        <img
          src={LOGO_LIGHT}
          alt="Sonar End User Portal"
          className="app-header__logo-img app-header__logo-img--light"
        />
        <img
          src={LOGO_DARK}
          alt=""
          className="app-header__logo-img app-header__logo-img--dark"
          aria-hidden
        />
      </a>
      <div className="app-header__actions">
        <McButton
          fit="small"
          variant="plain"
          appearance="neutral"
          icon={isDark ? "sun" : "moon"}
          click={toggleTheme}
          label=""
          aria-label=""
        />
        <div className="app-header__profile">
          <McAvatar
            initials={initials}
            info={displayName}
            label={displayName}
          />
          <span className="app-header__profile-name">{displayName}</span>
        </div>
      </div>
    </header>
  );
}

export default AppHeader;
